import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Field, reduxForm, change } from 'redux-form'
import { Translate, I18n } from 'react-redux-i18n'
import Grid from 'material-ui/Grid'

import { signIn, setStage } from 'modules/users/sessions'
import ValidationErrors from '../validation_errors'
import Group from '../group'
import Submit from '../submit'
import errorsSelector from 'selectors/errors'

const TwoFactorForm = ({ pristine, submitting, handleSubmit, setStage, errors }) => (
  <form onSubmit={handleSubmit} className="short-form">
    <div className="alert card-alert">
      <p>{I18n.t('users.2fa.alert')}</p>
    </div>
    <ValidationErrors errors={errors} />
    <br />
    <Grid container direction="column">
      <Grid item>
        <Field
          name="otp"
          type="text"
          component={Group}
          label={I18n.t('activerecord.attributes.user.otp_attempt')}
          required
          autoFocus
          autoComplete="off"
        />
      </Grid>
      <Grid item>
        <br />
        <div className="text-center">
          <div>
            <Submit
              className="btn-card-login-submit"
              value={I18n.t('users.2fa.submit')}
              disabled={pristine || submitting}
            />
          </div>
          <br />
          <p>
            <Link to="/users/sign_in" onClick={e => e.preventDefault() || setStage(0)}>
              <Translate value="users.2fa.back" />
            </Link>
          </p>
        </div>
      </Grid>
    </Grid>
  </form>
)

class TwoFactorFormContainer extends Component {
  componentDidMount() {
    const { changeFormField } = this.props
    changeFormField('sign_in', 'otp', '')
  }

  render() {
    return <TwoFactorForm {...this.props} />
  }
}

const mapStateToProps = state => ({
  errors: errorsSelector('users.sessions.index', 'validation_error')(state)
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({ signIn, setStage, changeFormField: change }, dispatch)

const ReduxForm = connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'sign_in',
    onSubmit: (props, dispatch, { signIn }) => signIn(props),
    onSubmitSuccess: (result, dispatch, { reset }) => reset(),
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
  })(TwoFactorFormContainer)
)

export default () => (
  <div>
    <h2>
      <Translate value="users.2fa.h" />
    </h2>
    <ReduxForm />
  </div>
)



// WEBPACK FOOTER //
// ./src/containers/pages/users/sign_in/two_factor.js